import React from "react";
import { Modal } from "react-bootstrap";
import { Worker, Viewer } from "@react-pdf-viewer/core";

const PdfViewerModal = ({ show, onHide, pdfUrl }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>PDF Viewer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {pdfUrl ? (
          <div style={{ height: "500px" }}>
            <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@3.0.279/build/pdf.worker.min.js`}
            >
              <Viewer fileUrl={pdfUrl} />
            </Worker>
          </div>
        ) : (
          <p>No PDF available</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PdfViewerModal;
